<template>
  <div class="categories">
    <router-link
        :to="translations.i18nRoute({ name: 'store', query: { categoriesSlugs: category.node.slug } })"
        class="categories__block"
        v-for="category in categories"
        :key="category.node.uuid"
    >
      <img :src="category.node.image" :alt="category.node.name">
      <p>{{ category.node.name }}</p>
    </router-link>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {useCategoryStore} from "@/stores/category.js";
import translations from "@/core/helpers/translations.js";

const categoryStore = useCategoryStore()

const categories = computed(() => categoryStore.categories)
</script>

<style lang="scss" scoped>
.categories {
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  &__block {
    height: 310px;
    display: grid;
    place-items: center;
    position: relative;
    overflow: hidden;

    & img {
      transition: 0.2s;
      position: absolute;
      height: 100%;
      object-fit: cover;
      width: 100%;
    }

    & p {
      position: relative;
      z-index: 1;
      color: #F3F3F3;
      text-align: center;
      font-size: 64px;
      font-weight: 700;
    }

    @include hover {
      & img {
        transform: scale(1.1);
        opacity: 0.7;
        filter: blur(2px);
      }
    }
  }
}

@media (max-width: 1100px) {
  .categories {
    &__block {
      & p {
        font-size: 32px;
      }
    }
  }
}

@media (max-width: 700px) {
  .categories {
    &__block {
      height: 250px;

      & p {
        font-size: 24px;
      }
    }
  }
}

@media (max-width: 500px) {
  .categories {
    display: flex;
    flex-direction: column;

    &__block {
      height: 150px;

      & p {
        font-size: 24px;
      }
    }
  }
}
</style>